var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 37.6",
    style: {
      enableBackground: "new 0 0 100 37.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,20.2h6c1.6,0,3.2,0.4,4.6,1.2c-0.4-2.3-2.3-3.9-4.6-3.9h-6c-1.6,0-3.2-0.4-4.6-1.2 C8.9,18.6,10.8,20.2,13.1,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,26.9h6c2.3,0,4.3-1.7,4.6-3.9c-1.4,0.8-3,1.2-4.6,1.2h-6c-1.6,0-3.2-0.4-4.6-1.2 C8.9,25.3,10.8,26.9,13.1,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,13.5c1.6,0,3.2,0.4,4.6,1.2c-0.4-2.3-2.3-3.9-4.6-3.9h-6c-2.3,0-4.3,1.7-4.6,3.9c1.4-0.8,3-1.2,4.6-1.2 C13.1,13.5,19.1,13.5,19.1,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,37.6c4.7,0,9.2-1.7,12.6-4.9c-4.1,1.4-8.3,2.2-12.6,2.2h-6.9c-4.3,0-8.6-0.7-12.6-2.2 c3.5,3.1,8,4.9,12.6,4.9H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,2.7c4.3,0,8.6,0.7,12.6,2.2C28.7,1.7,24.2,0,19.6,0h-6.9C8,0,3.5,1.7,0,4.9c4.1-1.4,8.3-2.2,12.6-2.2 H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,5.5h-6C10,5.5,7,7.1,5.3,9.7c2.3-1,4.8-1.5,7.4-1.5h6.9c2.5,0,5,0.5,7.4,1.5C25.2,7,22.2,5.5,19.1,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,32.3h6c3.1,0,6.1-1.6,7.8-4.2c-2.3,1-4.8,1.5-7.4,1.5h-6.9c-2.5,0-5-0.5-7.4-1.5 C7,30.8,10,32.3,13.1,32.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.9,16.8c-2.6-0.9-4.3-1.4-4.3-3c0-1.4,1.4-2,2.7-2c2.2,0,4.2,1.9,5.9,4.1h0.1v-4.1 c-1.8-0.8-3.8-1.2-5.7-1.2c-3.8-0.1-6.5,1.8-6.5,4.7c0,2.7,2,4.1,5.4,5.3c2.7,0.9,4.2,1.5,4.2,3.1c-0.1,1.4-1.2,2.4-2.6,2.3h-0.1 c-2.4,0-4.6-2.4-6.4-4.3h-0.3v4.2c2,0.9,4.1,1.4,6.4,1.5c3.2,0,6.2-1.6,6.2-5.3C52,19.6,50.5,18,46.9,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,23v-7.3c0-3.1-2-5.1-5.9-5.1c-2.4,0.1-4.7,0.5-7,1.2v4.1H55c0.5-0.8,4.6-4.1,6.6-4.1 c1.2,0,2.2,1.4,2.2,3.6v8.1c-0.7,0.8-1.6,1.4-2.7,1.4c-1.8,0-3.1-1.4-3.1-3.1v-0.1c0-2,1.6-3.8,4.9-3.4v-0.1 c-1.4-1.1-3.1-1.5-4.9-0.9c-2.7,0.7-4.3,2.4-4.3,5c0,2.7,2.2,5,5,5c0.1,0,0.3,0,0.4,0c2,0,3.8-0.9,4.9-2.6c0.3,1.5,1.6,2.6,3.1,2.4 c1.4,0.1,2.7-0.8,3-2.2v-0.1C68.5,25.4,67.8,24.7,67.8,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.8,10.7H81v0.1c0.4,1.6,0.7,3.1,0.8,4.7V22c0,0.7,0,1.4,0.1,2c0.1,0.9,0.3,1.9,0.7,2.8h4.1v-0.1 c-0.4-1.6-0.7-3.1-0.8-4.7V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.4,24.6c-1.6,0.1-3-1.2-3.1-2.8c0-0.1,0-0.4,0-0.5V10.7h-4.9v0.1c0.4,1.6,0.7,3.1,0.8,4.7v6.2 C71,24.6,73,27,75.8,27.3c0.3,0,0.5,0,0.8,0c1.9,0,3.5-1.2,4.1-3l-0.1-0.1C79.9,24.3,79.1,24.6,78.4,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.1,10.3c-3,0-3.9,3.4-3.9,3.4l0.1,0.1c1.8-0.7,3.6-0.1,4.9,1.2h0.1l0.7-4.5C99.5,10.4,98.8,10.3,98.1,10.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.2,10.7h-4.9v0.1c0.4,1.6,0.7,3.1,0.8,4.7V22c0,1.6-0.3,3.2-0.8,4.7v0.1h5.5v-0.1c-0.4-1.6-0.7-3.1-0.8-4.7 V10.7H93.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaur);
export default __webpack_public_path__ + "static/media/Saur.df35101233b1e70a2f1e8b822ffede11.svg";
export { ForwardRef as ReactComponent };